const secretKeys = {
	MAP_API_KEY: 'AIzaSyCzH-FCXhV5-SlCbuaiUnKIOW8mP3vYkkA',
}

export default secretKeys
